import { boogRevision, type BoogMaterial } from './products';

export interface BoogSurface {
  background: string; foreground: string; text: string; fontSize: number;
  textX: number; textY: number; pattern: 'none' | 'arches' | 'stripes';
  image: string | null; imageScale: number; imageX: number; imageY: number;
}
export interface BoogDesign { revision: string; material: BoogMaterial; surfaces: BoogSurface[] }
export function defaultBoogDesign(material: BoogMaterial = 'multiplex_9mm'): BoogDesign {
  return { revision: boogRevision(material), material, surfaces: (material === 'forex_10mm_double' ? ['STUDIO', 'YOUR', 'SPACE', 'STUDIO', 'YOUR', 'SPACE'] : ['STUDIO', 'YOUR', 'SPACE']).map((text, index) => { const i = index % 3; return ({
    background: ['#ebd9bb', '#6d826c', '#d29978'][i], foreground: ['#52745d', '#f1e6cf', '#593a2c'][i],
    text, fontSize: 26, textX: 38, textY: 60, pattern: 'arches', image: null,
    imageScale: 100, imageX: 50, imageY: 50,
  }); }) };
}
export function validBoogDesign(value: unknown, material?: BoogMaterial): value is BoogDesign {
  if (!value || typeof value !== 'object') return false;
  const d = value as BoogDesign;
  return ['multiplex_9mm', 'forex_10mm_double'].includes(d.material) && (!material || d.material === material) && d.revision === boogRevision(d.material) && Array.isArray(d.surfaces) && d.surfaces.length === (d.material === 'forex_10mm_double' ? 6 : 3) && d.surfaces.every(s =>
    s && /^#[a-f0-9]{6}$/i.test(s.background) && /^#[a-f0-9]{6}$/i.test(s.foreground) &&
    typeof s.text === 'string' && s.text.length <= 60 && ['none', 'arches', 'stripes'].includes(s.pattern) &&
    (s.image === null || (typeof s.image === 'string' && /^https:\/\/[^/]+\.public\.blob\.vercel-storage\.com\//.test(s.image))) &&
    [['fontSize', 7, 65], ['textX', 0, 420], ['textY', 0, 440], ['imageScale', 20, 220], ['imageX', 0, 100], ['imageY', 0, 100]].every(([key, min, max]) => {
      const n = s[key as keyof BoogSurface]; return typeof n === 'number' && Number.isFinite(n) && n >= Number(min) && n <= Number(max);
    }));
}

